import React, { useState } from "react";
import Container from "../components/Container";
import Button from "../components/Button";
import AuthCard from "../components/AuthCard";
import AuthHeader from "../components/AuthHeader";
import InputField from "../components/InputField";
import AuthLink from "../components/AuthLink";
import { toast } from "react-hot-toast";
import { api } from "../services/http";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await api.auth.forgotPassword({ email });
      if (res.success) {
        toast.success(res.message || "Lien envoyé !");
        setSubmitted(true);
      } else {
        toast.error(res.message || "Une erreur est survenue");
      }
    } catch (error) {
      toast.error(error.message || "Erreur lors de l'envoi");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container className="min-h-screen bg-gradient-to-br from-[#E9FBF8] via-white to-[#FFEFD8] bg-bg-login bg-contain bg-bottom flex items-center justify-center py-10">
      <AuthCard>
        <AuthHeader />
        
        <div className="mt-6 text-center">
          <h2 className="text-[20px] font-bold text-[#1B1C33]">
            Mot de passe oublié ?
          </h2>
          <p className="text-[14px] text-[#6B7280] mt-2">
            {submitted 
              ? "Si un compte existe pour cet email, vous recevrez un lien de réinitialisation." 
              : "Entrez votre email pour recevoir un lien de réinitialisation."}
          </p>
        </div>

        {!submitted ? (
          <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
            <InputField
              label="Email"
              type="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="votre@email.com"
            />

            <div className="flex pt-4">
              <Button
                type="submit"
                className="w-full py-2.5 text-[14px]"
                disabled={loading}
              >
                {loading ? "Envoi en cours..." : "Envoyer le lien"}
              </Button>
            </div>
          </form>
        ) : (
          <div className="mt-8 flex justify-center">
            <Button
              onClick={() => setSubmitted(false)}
              className="w-full py-2.5 text-[14px] bg-white !text-[#FEA12B] border border-[#FEA12B]"
            >
              Renvoyer l'email
            </Button>
          </div>
        )}

        <div className="mt-8">
          <AuthLink
            text="Retour à la"
            linkText="Connexion"
            to="/login"
          />
        </div>
      </AuthCard>
    </Container>
  );
}
